const features = [
    {
        "id":1,
        "icon":"fas fa-language",
        "name":"Global Vocabulary",
        "content":"With a support of over 125 different languages and their variants communication has never been easier"
    },
    {
        "id":2,
        "icon":"fas fa-globe-asia",
        "name":"Streaming Speech Recognition ",
        "content":"Using web sockets and Google’s Speech to text API, streaming audio from the microphone and transcripting it real time has become possible."
    },
    {
        "id":3,
        "icon":"fas fa-font",
        "name":"Grammar Recognition",
        "content":"With Google’s API identifying grammar and separating a sentence into nouns, verbs and adjectives has become very convenient which helps in learning and understanding grammar for language learners."
    },
    {
        "id":4,
        "icon":"fas fa-server",
        "name":"Multi Client Support ",
        "content":"With web sockets our supports over 65,536 live real time connections "
    },
    {
        "id":5,
        "icon":"fas fa-sort-numeric-down",
        "name":"Content Filtering",
        "content":"Helps to filter out inappropriate and unprofessional content which keeps the communication more friendly and accessible"
    },
    {
        "id":6,
        "icon":"fas fa-sign-language",
        "name":"Speech Adaptation",
        "content":"Recognize domain specific terms and rare words by providing hints about the context of communication"
    }
    
    
];

export default features;